export default {"src":"/_next/static/media/unique_visitor_count.593b4778.svg","height":46,"width":46,"blurWidth":0,"blurHeight":0};